import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { COLORS, STYLES, SHADOWS } from '../../designSystem';

export default function Button({
  variant = 'primary',
  onClick,
  children,
  disabled = false,
  style,
  as = 'button',
  to,
}) {
  const [isHovered, setIsHovered] = useState(false);

  const getBaseStyle = () => {
    switch (variant) {
      case 'primary':
        return STYLES.buttonPrimary;
      case 'secondary':
        return STYLES.buttonSecondary;
      case 'ghost':
        return STYLES.buttonGhost;
      case 'small':
        return STYLES.buttonSmall;
      case 'danger':
        return {
          ...STYLES.buttonPrimary,
          backgroundColor: COLORS.ERROR,
        };
      default:
        return STYLES.buttonPrimary;
    }
  };

  const getHoverStyle = () => {
    if (disabled) return {};

    switch (variant) {
      case 'primary':
        return {
          backgroundColor: COLORS.ACTION_PRIMARY_HOVER,
          boxShadow: SHADOWS.LG,
          transform: 'translateY(-2px)',
        };
      case 'secondary':
        return {
          backgroundColor: COLORS.BG_SURFACE_SECONDARY,
        };
      case 'ghost':
        return {
          color: COLORS.LINK_HOVER,
        };
      case 'small':
        return {
          backgroundColor: COLORS.PRIMARY_DARK,
        };
      case 'danger':
        return {
          backgroundColor: '#b91c1c',
          boxShadow: SHADOWS.LG,
          transform: 'translateY(-2px)',
        };
      default:
        return {};
    }
  };

  const baseStyle = getBaseStyle();
  const hoverStyle = isHovered ? getHoverStyle() : {};
  const disabledStyle = disabled ? { opacity: 0.6, cursor: 'not-allowed' } : {};

  const finalStyle = {
    ...baseStyle,
    ...hoverStyle,
    ...disabledStyle,
    ...style,
  };

  if (as === 'link' || as === Link) {
    return (
      <Link
        to={to}
        style={finalStyle}
        onMouseEnter={() => !disabled && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={onClick}
      >
        {children}
      </Link>
    );
  }

  return (
    <button
      style={finalStyle}
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={() => !disabled && setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
    </button>
  );
}
